// @flow
import React, { Component } from 'react';
import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import { sanitizeRouteParams } from 'metaup/routing/routingUtils';
import type { Routes } from 'metaup/routing/routingUtils';
import { listOfflineBranches, listOfflineCuts, listOfflineDays } from './model/OfflineBranch.client';
import ErrorCapsule from '../core/exceptions/ErrorCapsule';
import OfflineCutsPageView from './views/OfflineCutsPageView';
import type { OfflineCutsPageViewProps } from './views/OfflineCutsPageView';

const branchShape = '{ officeId officeName }';
const dayShape = '{ officeId date total syncedAt }';
const cutShape = '{ id date time brand device variant }';

const initialState = { branches: null, days: null, date: null, cuts: null };

const ACTION_SET = 'offlineTokens/cuts/ACTION_SET';

function setState(patch) {
  return { type: ACTION_SET, patch };
}

export async function loadBranchList() {
  try {
    return setState({ branches: await listOfflineBranches(branchShape) });
  } catch (err) {
    return setState({ branches: new ErrorCapsule(err, () => [loadBranchList()]) });
  }
}

// Дни грузим списком, самый свежий открываем сразу — обычно смотрят его.
export async function loadDays(officeId: string) {
  try {
    const days = await listOfflineDays(officeId, dayShape);
    const date = days.length ? days[0].date : null;
    return [
      setState({ days, date, cuts: null }),
      date ? loadCuts(officeId, date) : setState({ cuts: [] }),
    ];
  } catch (err) {
    return setState({ days: new ErrorCapsule(err, () => [loadDays(officeId)]) });
  }
}

export async function loadCuts(officeId: string, date: string) {
  try {
    return setState({ date, cuts: await listOfflineCuts(officeId, date, cutShape) });
  } catch (err) {
    return setState({ cuts: new ErrorCapsule(err, () => [loadCuts(officeId, date)]) });
  }
}

export function offlineCutsReducer(state = initialState, action) {
  switch (action.type) {
    case ACTION_SET:
      return { ...state, ...action.patch };
    default: return state;
  }
}

const OfflineCutsPage = connect(
  ({ offlineTokens }) => ({ ...offlineTokens.cuts }),
)(class extends Component<OfflineCutsPageViewProps> {
  constructor(props) {
    super(props);
    props.dispatch([setState(initialState), loadBranchList()]);
    if (props.officeId) {
      props.dispatch(loadDays(props.officeId));
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.officeId !== this.props.officeId && this.props.officeId) {
      this.props.dispatch(loadDays(this.props.officeId));
    }
  }
  componentWillUnmount() {
    this.props.dispatch(setState(initialState));
  }
  render() {
    return (
      <OfflineCutsPageView
        {...this.props}
        onSelectDate={date => this.props.dispatch(loadCuts(this.props.officeId, date))}
      />
    );
  }
});

export function offlineCutsPageRoutes(): Routes {
  return [{
    title: 'Резы офлайн-каттера',
    path: ['/offline/cuts/', '/offline/cuts/:officeId'],
    // В isEnabled приходит только isUser/isGuest/authState, isAdmin там нет.
    // Раздел и так виден в меню лишь админам, а сервер на всех запросах
    // требует админа и отвечает Access denied.
    isEnabled: ({ isUser }) => isUser,
    render: params => (
      <OfflineCutsPage
        {...sanitizeRouteParams(params, { officeId: '?id' }, { officeId: null })}
      />
    ),
    nav: { isWide: true },
    design: null,
  }];
}
